import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'lib-ph-bhp-pie-chart',
    templateUrl: './ph-bhp-pie-chart.component.html',
    styleUrls: ['./ph-bhp-pie-chart.component.css']
})
export class PhBhpPieChartComponent implements OnInit {


    public productPackageChart = {
        title: {
            text: "",
            position: "top",
            visible: false
        },
        legend: {
            text: "",
            position: "bottom",
            visible: true
        },
        donutCenterText: {
            enable: false
        },
        seriesDefaults: {
            type: "donut",
            area: {
                line: {
                    style: "smooth",
                    visible: false
                }
            },
            startAngle: -50,
            labels: {
                visible: true,
                font: "12px OpenSans-Regular",
                background: "transparent",
                color: "#ffffff",
                format: "{0}%",
            },
            border:{
                width: 0, color: '#7990d8', opacity: 0
            }
        },
        series: [{
            name: [],
            data: [{
                //category: "Observe Observation",
                //value: 14,
                color: "#1a237e"
            }, {
                //category: "Observe Complete",
                //value: 26,
                color: "#303f9f"
            }, {
                //category: "Observe  SOP Flex",
                //value: 60,
                color: "#4a64b4"
            }]
        }],
        valueAxis: {
            labels: {
            },
            title: {
                text: ""
            },
            line: {
                visible: false
            },
            axisCrossingValue: 0,
            visible: false,
            majorGridLines: {
                visible: false
            },
            minorGridLines: {
                visible: false
            }
        },
        categoryAxis: {
            categories: [], // ['Observe Observation', 'Observe Complete', 'Observe SOP Flex'],
            majorGridLines: {
                visible: false
            },
            minorGridLines: {
                visible: false
            },
            labels: {
                rotation: "auto"
            },
            line: {
                visible: false
            }
        },
        tooltip: {
            visible: false,
            format: "{0}%",
            background: "#c2c2c2",
        }
    }

    constructor() { }
    ngOnInit() {
    }
    labelColor(e: any): string {
        return (e.dataItem.color === '#fff' || e.dataItem.color === '#ffffff') ? '#1a237e' : "#fff";
    }

}
